import type { QueryKey } from '@tanstack/react-query';
import type { GetPliantCardsParams, GetPliantTransactionsParams } from './api';

export const PLIANT_TRANSACTIONS_KEY = (
  params?: Partial<GetPliantTransactionsParams['params']>
): QueryKey => {
  const base = 'pliant-transactions';
  if (params) {
    return [base, params];
  }
  return [base];
};

export const PLIANT_CARDS_KEY = (
  params?: Partial<GetPliantCardsParams['params']>
): QueryKey => {
  const base = 'pliant-cards';
  if (params) {
    return [base, params];
  }
  return [base];
};

export const PLIANT_TRANSACTION_KEY = (
  pliantTransactionId: string
): QueryKey => {
  return ['pliant-transaction', pliantTransactionId];
};
